// Shared icon badge: gradient fill, inner highlight and a tinted shadow, so
// every icon on the marketing pages reads as one family. `tone="soft"` is the
// quieter outlined variant for dense lists.
const SIZES = {
  sm: "h-10 w-10 rounded-xl [&>svg]:h-5 [&>svg]:w-5",
  md: "h-12 w-12 rounded-xl [&>svg]:h-6 [&>svg]:w-6",
  lg: "h-14 w-14 rounded-2xl [&>svg]:h-7 [&>svg]:w-7",
};

const TONES = {
  solid:
    "bg-gradient-to-br from-[#FF8533] to-[#FF6B00] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.4),0_8px_18px_rgba(255,107,0,0.28)]",
  soft:
    "bg-gradient-to-br from-[#FFF3E9] to-white text-[#FF6B00] ring-1 ring-inset ring-[#FF6B00]/20 shadow-[0_4px_12px_rgba(255,107,0,0.10)]",
};

export default function IconTile({ icon: Icon, size = "md", tone = "solid", className = "" }) {
  return (
    <span
      aria-hidden
      className={`grid shrink-0 place-items-center transition-transform duration-300 ease-out group-hover:-translate-y-0.5 group-hover:scale-105 ${SIZES[size]} ${TONES[tone]} ${className}`}
    >
      <Icon strokeWidth={1.75} />
    </span>
  );
}
